export enum BRANDED_VERSION {
    V1 = '',
    V2 = 'lh-roomie-v2'
}
